import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

export enum DialogVariants {
  ERROR,
  SUCCESS,
  NONE,
}

interface AlertMessageDialogProps {
  title?: string;
  body: React.ReactNode;
  variant?: DialogVariants;
  isModalVisible: boolean;
  onHideModal?: () => void;
  showExtraButton?: boolean;
  extraButtonLabel?: string;
  extraButtonOnClick?: () => void;
}

export function AlertMessageDialog({
  title,
  body,
  variant: messageType,
  isModalVisible,
  showExtraButton = false,
  extraButtonLabel = 'Save Changes',
  extraButtonOnClick = () => {},
  onHideModal = () => {},
}: AlertMessageDialogProps) {
  const [show, setShow] = useState(isModalVisible);
  const handleClose = () => {
    setShow(false);
    onHideModal();
  };

  function headerClass() {
    if (messageType === DialogVariants.SUCCESS) {
      return 'text-success';
    }
    if (messageType === DialogVariants.ERROR) {
      return 'text-danger';
    }
    return 'text-black';
  }

  function getCloseBtnVariant() {
    if (messageType === DialogVariants.SUCCESS) {
      return 'success';
    }
    if (messageType === DialogVariants.ERROR) {
      return 'danger';
    }
    return 'primary';
  }

  return (
    <>
      <Modal className="border-success" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className={headerClass()}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          {showExtraButton && (
            <Button
              variant="primary"
              onClick={() => {
                extraButtonOnClick();
                handleClose();
              }}
            >
              {extraButtonLabel}
            </Button>
          )}
          <Button
            // eslint-disable-next-line no-nested-ternary
            variant={getCloseBtnVariant()}
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

AlertMessageDialog.defaultProps = {
  title: '',
  variant: DialogVariants.NONE,
  onHideModal: () => {},
};
